module.exports = __webpack_public_path__ + "static/media/corpo.dacc73ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/corpo.jpg
// module id = 63
// module chunks = 0